(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/result-start.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/result-start.js');

'use strict';

const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  selectedResultAtom = _svs$lyckoplatsen$com.selectedResultAtom,
  correctionStepAtom = _svs$lyckoplatsen$com.correctionStepAtom,
  autoPlayLatestCorrectionTlAtom = _svs$lyckoplatsen$com.autoPlayLatestCorrectionTlAtom;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useSetAtom = _jotai.useSetAtom;
const Button = svs.ui.ReactButton;
const productMapping = svs.lyckoplatsen.components.shared_constants.productMapping;
const CORRECTION_STEP = svs.lyckoplatsen.components.shared_constants.CONSTANTS.CORRECTION_STEP;
const ResultStartSvg = svs.lyckoplatsen.components.page_result.react.components.ResultStartSvg;
const CharityPayout = svs.lyckoplatsen.components.shared_charity_payout.react.components.CharityPayout;
const ResultStart = () => {
  const selectedResult = useAtomValue(selectedResultAtom);
  const setCorrectionStep = useSetAtom(correctionStepAtom);
  const setAutoPlay = useSetAtom(autoPlayLatestCorrectionTlAtom);
  return React.createElement("div", {
    className: "lp-result-start-wrapper"
  }, React.createElement("div", {
    className: "lp-result-start"
  }, React.createElement("div", {
    className: "result-start-body f-content"
  }, React.createElement("div", {
    className: "lp-start_image align-center padding-2"
  }, React.createElement(ResultStartSvg, null)), React.createElement("div", {
    className: "lp-header"
  }, React.createElement("h3", null, "Starta dragningen f\xF6r att se den vinnande platsen.")), React.createElement(Button, {
    block: true,
    size: 300,
    onClick: () => {
      setCorrectionStep(productMapping.isLyckoplatsenPrimary(selectedResult.productId) ? CORRECTION_STEP.TOPWIN : CORRECTION_STEP.PLACE);
      setAutoPlay(true);
    }
  }, "Starta dragningen"), React.createElement(Button, {
    className: "margin-top-2 margin-bottom-2",
    block: true,
    transparent: true,
    inverted: true,
    size: 300,
    onClick: () => {
      setCorrectionStep(CORRECTION_STEP.RESULT);
    }
  }, "Visa resultat direkt"))), productMapping.isLyckoplatsenPrimary(selectedResult.productId) && React.createElement(CharityPayout, null));
};
setGlobal('svs.lyckoplatsen.components.page_result.react.components', {
  ResultStart
});

 })(window);